import { IExportColumnData } from "api/interfaces";
import { lang } from "i18nLang";
import { copyJson } from "utils";

export const measurementsColumns: IExportColumnData[] = [
  {
    dataKey: "description",
    label: lang("exportData.description"),
    type: "string",
    colspan: 2,
    width: 20.71,
  },
  {
    dataKey: "total",
    label: lang("exportData.measurements.total"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "allDiscountsTotal",
    label: lang("exportData.measurements.discounts"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "grossTotal",
    label: lang("exportData.measurements.grossTotal"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "retentionAdvance",
    label: lang("exportData.measurements.retentionAdvance"),
    type: "monetary",
    width: 23.71,
  },
  {
    dataKey: "taxesTotal",
    label: lang("exportData.measurements.taxes"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "receivableTotal",
    label: lang("exportData.measurements.netTotal"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "status",
    label: lang("exportData.measurements.status"),
    type: "string",
    width: 20.71,
  },
  {
    dataKey: "invoiceNumber",
    label: lang("exportData.measurements.invoiceNumber"),
    type: "string",
    width: 10.71,
  },
  {
    dataKey: "invoiceSerial",
    label: lang("exportData.measurements.invoiceSerial"),
    type: "string",
    width: 10.71,
  },
  {
    dataKey: "invoiceDate",
    label: lang("exportData.measurements.invoiceDate"),
    type: "string",
    width: 18.71,
  },
  {
    dataKey: "period",
    label: lang("exportData.measurements.period"),
    type: "string",
    width: 22.71,
  },
  {
    dataKey: "orderCode",
    label: lang("exportData.measurements.orderCode"),
    type: "string",
    width: 20.71,
  },
  {
    dataKey: "balanceToMeasure",
    label: lang("exportData.measurements.balanceToMeasure"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "measuredPercentual",
    label: lang("exportData.measurements.measuredPercentual"),
    type: "numeric",
    width: 20.71,
  },
  {
    dataKey: "accumulatedPercentual",
    label: lang("exportData.measurements.accumulatedPercentual"),
    type: "numeric",
    width: 20.71,
  },
  {
    dataKey: "clientName",
    label: lang("exportData.measurements.clientName"),
    type: "string",
    width: 45.71,
  },
];

export const additivesColumns: IExportColumnData[] = [
  {
    dataKey: "structured",
    label: lang("indicatorsPage.addsAndCancels.structured"),
    type: "string",
    width: 12,
  },
  {
    dataKey: "description",
    label: lang("indicatorsPage.addsAndCancels.description"),
    type: "string",
    width: 22.71,
    colspan: 2,
  },
  {
    dataKey: "quantityApplied",
    label: lang("indicatorsPage.addsAndCancels.quantityApplied"),
    type: "numeric",
    width: 20.71,
  },
  {
    dataKey: "totalApplied",
    label: lang("indicatorsPage.addsAndCancels.totalApplied"),
    type: "monetary",
    width: 20.71,
  },
  {
    dataKey: "dateFormated",
    label: lang("indicatorsPage.addsAndCancels.date"),
    type: "string",
    width: 15,
  },
  {
    dataKey: "userName",
    label: lang("indicatorsPage.addsAndCancels.userName"),
    type: "string",
    width: 20.71,
  },
];

export const cancellationsColumns: IExportColumnData[] =
  copyJson(additivesColumns);
cancellationsColumns[2].label = lang(
  "indicatorsPage.addsAndCancels.quantityCanceled"
);

export const otherChangesColumns: IExportColumnData[] = [
  {
    dataKey: "structured",
    label: lang("indicatorsPage.addsAndCancels.structured"),
    type: "string",
    width: 12,
  },
  {
    dataKey: "descriptionBefore",
    label: lang("indicatorsPage.addsAndCancels.descriptionBefore"),
    type: "string",
    width: 22.71,
    colspan: 2,
  },
  {
    dataKey: "descriptionAfter",
    label: lang("indicatorsPage.addsAndCancels.descriptionAfter"),
    type: "string",
    width: 22.71,
    colspan: 2,
  },
  {
    dataKey: "quantityBefore",
    label: lang("indicatorsPage.addsAndCancels.quantityBefore"),
    type: "numeric",
    width: 20.71,
  },
  {
    dataKey: "quantityAfter",
    label: lang("indicatorsPage.addsAndCancels.quantityAfter"),
    type: "numeric",
    width: 20.71,
  },
  {
    dataKey: "dateFormated",
    label: lang("indicatorsPage.addsAndCancels.date"),
    type: "string",
    width: 15,
  },
  {
    dataKey: "userName",
    label: lang("indicatorsPage.addsAndCancels.userName"),
    type: "string",
    width: 20.71,
  },
];
